'use client'

import { Card, Group, Text } from '@mantine/core'
import { RiArrowRightSLine } from '@remixicon/react'
import Image from 'next/image'
import { FC } from 'react'
import classes from './PersonaCardDesign.module.css'

interface PersonaCardDesignProps {
  image: string
  description: string
  cta: string
  ctaUrl: string
  variantColor?: string
}

export const PersonaCardDesign: FC<PersonaCardDesignProps> = ({
  image,
  description,
  cta,
  ctaUrl,
}) => {
  return (
    <Card
      shadow='sm'
      radius='14px'
      className={classes.card}
      component='a'
      href={ctaUrl}
      target='_blank'
    >
      <div>
        <Group mb='xs'>
          <Image src={image} alt='Partment' width={100} height={30} />
        </Group>

        <Text className={classes.description}>{description}</Text>
      </div>

      <Group mt={{ base: 'xs', lg: 'md' }} className={classes.ctaGroup}>
        <Text className={classes.ctaText}>{cta}</Text>
        <RiArrowRightSLine size={18} />
      </Group>
    </Card>
  )
}
